import * as React from 'react';
import classnames from 'classnames';

import styles from './FormField.module.css';

type Props = {
  label?: string;
  children: JSX.Element;
  helpText?: string;
};

function FormField(props: Props): JSX.Element {
  return (
    <div className={styles.container}>
      <div className={styles.label_container}>
        {props.label && (
          <div
            className={classnames({
              [styles.label]: true,
            })}
          >
            {props.label}
            {props.helpText && (
              <span className={styles.help_text}>
                {' '}
                &middot; {props.helpText}
              </span>
            )}
          </div>
        )}
      </div>
      <div className={styles.content}>{props.children}</div>
    </div>
  );
}

export default FormField;
